import { render } from "./advance-applay-detail.vue?vue&type=template&id=dbeca232&scoped=true&ts=true"
import script from "./advance-applay-detail.vue?vue&type=script&lang=ts"
export * from "./advance-applay-detail.vue?vue&type=script&lang=ts"

import "./advance-applay-detail.vue?vue&type=style&index=0&id=dbeca232&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbeca232"]])

export default __exports__